import tpl from './developDefinitions.html';
import "./developDefinitions.css";

class DevelopDefinitions {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
    }
}

export {
    DevelopDefinitions
}